﻿import React from 'react';
import {styled} from "@mui/material/styles";


type PropsAreEqual<P> = (
  prevProps: Readonly<P>,
  nextProps: Readonly<P>
) => boolean;

const withGrayTransparency = <P extends {}>(
  component: {
    (props: P): Exclude<React.ReactNode, undefined>;
    displayName?: string;
  },
  propsAreEqual?: PropsAreEqual<P> | false,

  componentName = component.displayName ?? component.name
): {
  (props: P): React.JSX.Element;
  displayName: string;
} => {

  const StyledComponent = styled(component as React.ComponentType<P>)(() => ({
    color: 'rgba(0, 0, 0, 0.6)',
    fontWeight: 400,
  }));

  function WithGrayTransparency(props: P) {
    //Do something special to justify the HoC.
    return <StyledComponent {...props} />;
  }

  WithGrayTransparency.displayName = `withGrayTransparency(${componentName})`;

  const wrappedComponent = propsAreEqual === false ? WithGrayTransparency : React.memo(WithGrayTransparency, propsAreEqual);

  //copyStaticProperties(component, wrappedComponent);

  return wrappedComponent as typeof WithGrayTransparency
};

export { withGrayTransparency }
